import PropTypes from 'prop-types'
import React from 'react'
import { TextInput } from 'SRC/ui/FormElements'

export const Name = ({isFullWidth, label, isBusinessUser}) =>
  <TextInput
    id='name'
    name='name'
    label={label}
    isFullWidth={isFullWidth}
    isRequired
    allowedCharacters={isBusinessUser ? ['lettersWithDots', 'numbers'] : ['letters']}
  />

Name.propTypes = {
  isFullWidth: PropTypes.bool.isRequired,
  isBusinessUser: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired
}

Name.defaultProps = {
  isFullWidth: false
}
